(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Helper, Config, Model, Service, Handler, Message, $, Password) {

    /* CREAR CUENTA PASO 1 */
    Controller.crearCuentaNativoView = function (error) {
        Helper.callView('CREAR_CUENTA_NATIVO', {
            Error: error
        }, function () {
            if ($("#crear_cuenta_nativo_email").val()) $("button.login").addClass("active");
        }, true);
    }

    Controller.crearCuentaDirectaView = function (error) {
        Helper.callView('CREAR_CUENTA_DIRECTO', {
            Error: error
        }, function () {
            Helper.Recaptcha.render('crear_cuenta_directo_recaptcha',
                function submit() {

                }, function expired() {
                    //Helper.displayCustomMessageError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_EXPIRADO']);
                    //Helper.Recaptcha.reset();
                });
            $(".val-nueva-clave").strongpass();
            if ($("#crear_cuenta_directa_email").val()) $("button.login").addClass("active");
        }, true);
    }

    Controller.crearCuentaNativo = function () {
        var email = $("#crear_cuenta_nativo_email");
        Helper.checkNextButton(email);
        if (Helper.Validators.email.test(email.val())) {
            Helper.changeStatus(email, true);
            Model.Usuario.Email = email.val();
            Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
                Handler.existeMailUsuarioCrearCuentaResponseHandler(res, status, xhr);
            }, false, {
                showPreloader: true
            });
        } else {
          Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);
        }
    }


    Controller.crearCuentaDirecta = function () {
        var email = $("#crear_cuenta_directa_email");
        var password = $("#crear_cuenta_directo_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        Helper.checkNextButton(email);
        if (Helper.Validators.email.test(email.val())) {
            if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val())) {

                Helper.changeStatus(email, true);
                Model.Usuario.UsuarioUsuario = (Helper.Validators.username.test(email.val()) ? email.val() : (Helper.Validators.email.test(email.val()) ? email.val() : null));
                Model.Usuario.Email = (Helper.Validators.email.test(email.val()) ? email.val() : null);
                Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
                    Handler.existeMailUsuarioCrearCuentaDirectaResponseHandler(res, status, xhr);
                }, false, {
                    showPreloader: true
                });
            } else if (!Helper.Recaptcha.isSubmitted()) {              
                Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
            } else {
                // Viene por password
                //if (password.val().length < 8 || password.val().length > 20) {
                //    LN.Helper.changeStatus(password, LN.Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
                //} else {
                //    if (!Helper.Validators.passwordRegistro.test(password.val())) {
                //        LN.Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                //    }
                //}

                //if (Helper.Recaptcha.isSubmitted())
                //    Helper.Recaptcha.reset();
            }
        } else {
          Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);            
        }
    }

    Controller.crearCuentaDirectaPassword = function () {
        var password = $("#crear_cuenta_directo_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        //if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val())) {
        Model.Usuario.Clave = password.val();
        Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();

        // Todo OK
        Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()));
        Service.ajaxPost('/Usuario/AltaUsuario', Model.Usuario, function (res, status, xhr) {
            Handler.altaUsuarioResponseHandler(res, status, xhr);
        }, false, {
            showPreloader: true,
            hidePreloader: true
        });        
    }
    /* FIN CREAR CUENTA PASO 1 */

    /* CREAR CUENTA PASO 2 */
    Controller.crearCuentaDatosView = function (nativo) {
        Helper.callView('CREAR_CUENTA_DATOS', {
            isNativo: nativo || nativo == true
        }, Controller.crearCuentaBindings, true);
    }

    Controller.crearCuentaBindings = function () {
        // Solo permitir inputs de letras y keys de navegaci�n
        $(document).on("keydown", "#crear_cuenta_datos_nombre, #crear_cuenta_datos_apellido", function (e) {
            var keycode = event.which;
            if (!(keycode == 13 || keycode == 32 || keycode == 8 || keycode == 9 || keycode == 37 || keycode == 39 || keycode == 46 || (keycode >= 65 && keycode <= 90))) {
                e.preventDefault();
            }
        })
    }

    Controller.crearCuentaDatos = function () {
        var nombre = $("#crear_cuenta_datos_nombre");
        var apellido = $("#crear_cuenta_datos_apellido");
        if (Helper.Validators.name.test(nombre.val()) && nombre.val().trim() != "" && Helper.Validators.lastname.test(apellido.val()) && apellido.val().trim() != "") {
            Helper.changeStatus(nombre, true);
            Helper.changeStatus(apellido, true);
            Model.Usuario.UsuarioDetalleNombre = Helper.cleanSpecialCharsInput(nombre.val());
            Model.Usuario.UsuarioDetalleApellido = Helper.cleanSpecialCharsInput(apellido.val());
            Controller.crearCuentaPasswordView();
        } else {
          Helper.changeStatus(nombre, Helper.Validators.name.test(nombre.val()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
          Helper.changeStatus(apellido, Helper.Validators.lastname.test(apellido.val()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
          Helper.changeStatus(nombre, Helper.Validators.name.test(nombre.val().trim()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
          Helper.changeStatus(apellido, Helper.Validators.lastname.test(apellido.val().trim()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
        }
    }

    /* CREAR CUENTA PASO 2 */

    /* CREAR CUENTA PASO 3 */
    Controller.crearCuentaPasswordView = function () {
        Helper.callView('CREAR_CUENTA_PASSWORD', null, function () {
            Helper.Recaptcha.render('crear_cuenta_password_recaptcha');
            $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
        });
    }

    Controller.crearCuentaPassword = function () {
        var password = $("#crear_cuenta_password_password");
        var repetirPassword = $("#crear_cuenta_password_repetir_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
            //if (Password.canSubmit()) { LM la proxima te corto los dedos AD
            Model.Usuario.Clave = password.val();
            Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();
            if (password.val() === repetirPassword.val()) {
                // Todo OK
                Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()));
                Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()));
                Service.ajaxPost('/Usuario/AltaUsuario', Model.Usuario, function (res, status, xhr) {
                    Handler.altaUsuarioResponseHandler(res, status, xhr);
                }, false, {
                    showPreloader: true,
                    hidePreloader: true
                });
            } else {
                // Las passwords no coinciden
                if (Helper.Validators.password.test(password.val())) {
                    Helper.changeStatus(password, false);
                }
            }
        } else {
            if (password.val().length > 20) {
                LN.Helper.changeStatus(password, LN.Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
            } else {
                if (!Helper.Validators.passwordRegistro.test(password.val())) {
                    LN.Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                }
                else {
                    if (password.val() != repetirPassword.val()) {
                        LN.Helper.changeStatus(password, false, Message.Usuario['CLAVE_DIFIERE']);
                    }
                    //else {
                    //    Helper.changeStatus(password, false);
                    //}
                }
            }

            if (repetirPassword.val().length < 8 || repetirPassword.val().length > 20) {
                LN.Helper.changeStatus(repetirPassword, LN.Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
            } else {
                if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
                    //LN.Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                    LN.Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CLAVE_DIFIERE']);
                }
                else {
                    if (password.val() != repetirPassword.val()) {
                        LN.Helper.changeStatus(repetirPassword, false, Message.Usuario['CLAVE_DIFIERE']);
                    }
                    //else {
                    //    Helper.changeStatus(password, false);
                    //}
                }
            }

          if (!Helper.Recaptcha.isSubmitted()) {            
              Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
          }
            else Helper.Recaptcha.reset();
        }
    }

    /* CREAR CUENTA PASO 3 */

    Controller.crearCuentaValidarCodigoView = function (error) {
        Helper.callView('CREAR_CUENTA_VALIDAR_CODIGO', {
            Error: error
        }, function () {
            LN.Wcentrix && LN.Wcentrix.initChat();
            $('#crear_cuenta_validar_codigo_codigo').focus();
            //$("#usuario_email").html(Model.Usuario.Email);	
        }, true);
    }

    Controller.crearCuentaGracias = function () {
        Helper.callView('CREAR_CUENTA_GRACIAS');
    }
    Controller.grabarTokenTemporal = function (res, status, xhr) {
        var token = xhr.getResponseHeader("X-Token");
        Helper.setToken(token);
        Controller.crearCuentaValidarCodigoView();
    }

    Controller.crearCuentaReenviarCodigo = function () {
        Service.ajaxPost('/Usuario/ReenviarCodigo', Model.Usuario, function (res, status, xhr) {
            $('.atencion').hide(); //  Oculto todas las advertencias
            $('#aviso-reenvio').show();
            $('#crear_cuenta_validar_codigo_codigo').val('');
            $('#crear_cuenta_validar_codigo_codigo').focus();
            Helper.hidePreloader();
        }, null, {
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    }

    Controller.crearCuentaValidarCodigo = function () {
        var codigo = $("#crear_cuenta_validar_codigo_codigo");
        if (!Helper.Validators.confirmCode.test(codigo.val().trim())) {
            Helper.changeStatus(codigo, Helper.Validators.confirmCode.test(codigo.val()));
            return false;
        }

        Model.Usuario.Codigo = codigo.val();

        var request = {
            'UsuarioDetalleNombre': Model.Usuario.UsuarioDetalleNombre,
            'UsuarioDetalleApellido': Model.Usuario.UsuarioDetalleApellido,
            'Email': Model.Usuario.Email,
            'Clave': Model.Usuario.Clave,
            'Codigo': Model.Usuario.Codigo,
            'AutenticacionTipoId': '1',
            'SitioId': '1'
        }

        Service.ajaxPost('/Usuario/ValidarCodigoMailLogin', request, function (response, status, xhr) {
            Handler.validarCodigoMailLoginResponseHandler(response, status, xhr);

        }, null, {
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    }

    Controller.crearCuentaRedSocial = function () {
        Model.setXKey();
        var email = $("#crear_cuenta_red_social_email");
        if (Helper.Validators.email.test(email.val())) {
            Helper.changeStatus(email, true);
            Model.Usuario.Email = email.val();
            Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (data, status, xhr) {
                if (data.code == '0000') {
                    // El email ya existe
                  Helper.changeStatus(email, false, Message.Usuario['EMAIL_EXISTE'], Message.Analytics.Usuario['EMAIL_EXISTE']);
                } else {
                    // Continuar
                    Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
                        var token = xhr.getResponseHeader("X-Token");
                        var xvalue = xhr.getResponseHeader("X-Value");

                        if ((data.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                            logger && logger.error('GestionarRedSocial (Crear Cuenta) | sin headers ', { token, xvalue});
                        }
                        Model.unsetXKey();
                        Handler.loginResponseHandler(data, status, xhr);
                    }, null, {
                        sentHeader: true,
                        showPreloader: true,
                        hidePreloader: true
                    });
                }
            }, null, {
                showPreloader: true,
                hidePreloader: true
            });
        } else {
          Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);
        }
    }

})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Message, jQuery, Password.Validator);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/registro.js